import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  &:empty {
    display: none;
  }

  & > *:not(:last-child, .badge)::after {
    content: '|';
    margin: 0 ${sizes.xSmall};
    color: ${colors.gray4};
  }

  & > .badge {
    display: flex;
    gap: ${sizes.xSmall};
    margin-right: ${sizes.xSmall};
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  cursor: default;
`;

export const ItemContent = styled.div<{ concise?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ concise }) => concise ? sizes.xxSmall : sizes.xSmall};
  color: ${({ concise }) => concise ? colors.gray5 : colors.blue4};
`;
